// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorsComponent } from '@coa/app/errors/errors.component';
import { PageNotFoundComponent } from '@coa/app/errors/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    component: ErrorsComponent,
    children: [
      {
        path: 'page-not-found',
        component: PageNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorsRoutingModule {
}
